export default {
    namespaced: true,
    state: {
        // Filtros aplicados en la pantalla de señales potenciales
        mySignalsFilters: {
            tickerName: null,
            sector: null,
            status: null,
            sortBy: null,
            sortDesc: null
        },
        // Filtros aplicados en la pantalla de señales potenciales
        potentialSignalsFilters: {
            tickerName: null,
            sector: null,
            rangeDates: [],
            rangeDatesFormatted: null,
            minDate: null,
            signalPriceRange: [],
            signalVolumeRange: [],
            sortBy: null,
            sortDesc: null
        },
        // Filtros aplicados en la pantalla de señales activas
        activeSignalsFilters: {
            tickerName: null,
            sector: null,
            rangeDates: [],
            rangeDatesFormatted: null,
            minDate: null,
            signalPriceRange: [],
            signalVolumeRange: [],
            sortBy: null,
            sortDesc: null
        },
        // Filtros aplicados en la pantalla de señales cerradas
        closedSignalsFilters: {
            tickerName: null,
            sector: null,
            rangeSignalDates: [],
            rangeSignalDatesFormatted: null,
            rangeFinishedDates: [],
            rangeFinishedDatesFormatted: null,
            minDate: null,
            signalPriceRange: [],
            signalVolumeRange: [],
            sortBy: null,
            sortDesc: null
        },
        // Filtros aplicados en la pantalla de track record
        trackRecordFilters: {
            tickerName: null,
            sector: null,
            rangeSignalDates: [],
            rangeSignalDatesFormatted: null,
            rangeFinishedDates: [],
            rangeFinishedDatesFormatted: null,
            minDate: null,
            signalPriceRange: [],
            signalVolumeRange: [],
            sortBy: null,
            sortDesc: null
        },
    },
    mutations: {
        SET_OBJECT(state, { objectKey, newObject }) {
            state[objectKey] = { ...state[objectKey], ...newObject };
        },
        SET_SPECIFIC_FIELD(state, { objectKey, field, value }) {
            state[objectKey][field] = value;
        },
    },
    actions: {
        updateObject({ commit }, { objectKey, newObject }) {
            commit("SET_OBJECT", { objectKey, newObject });
        },
        updateSpecificField({ commit }, payload) {
            commit("SET_SPECIFIC_FIELD", payload);
        },
    },
    getters: {
        getObject: (state) => (objectKey) => state[objectKey],
        getSpecificField: (state) => (objectKey, field) => state[objectKey][field],
    },
};
